import axios from "axios";

const BASE_URL = "https://backdanlu.eu-4.evennode.com";

// ✅ GET: Traer pagos de estaciones
export const getPagoEstaciones = async ({ estacion, desde, hasta } = {}) => {
  const token = localStorage.getItem("token") || "";
  const q = new URLSearchParams();

  if (estacion) q.set("estacion", estacion);
  if (desde) q.set("desde", desde);
  if (hasta) q.set("hasta", hasta);

  const url = `${BASE_URL}/pagoestacion${q.toString() ? "?" + q.toString() : ""}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR GET /pagoestacion:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al obtener pagos de estación",
    };
  }
};

// ✅ GET: Traer un pago de estación por ID
export const getPagoEstacionById = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/pagoestacion/${id}`;

  try {
    const resp = await axios.get(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR GET /pagoestacion/:id:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al obtener pago de estación",
    };
  }
};

// ✅ POST: Crear pago de estación
export const postPagoEstacion = async (payload) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/pagoestacion`;

  try {
    const resp = await axios.post(url, payload, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR POST /pagoestacion:", error.response?.data);
    console.log("❌ STATUS:", error.response?.status);
    console.log("❌ MSG:", error.message);

    return {
      ok: false,
      error: error.response?.data || "Error al crear pago de estación",
    };
  }
};

// ✅ PUT: Actualizar pago de estación
export const putPagoEstacion = async (id, payload) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/pagoestacion/${id}`;

  try {
    const resp = await axios.put(url, payload, {
      headers: { "Content-Type": "application/json", token },
    });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR PUT /pagoestacion:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al actualizar pago de estación",
    };
  }
};

// ✅ DELETE: Anular pago de estación
export const deletePagoEstacion = async (id) => {
  const token = localStorage.getItem("token") || "";
  const url = `${BASE_URL}/pagoestacion/${id}`;

  try {
    const resp = await axios.delete(url, { headers: { token } });
    return resp.data;
  } catch (error) {
    console.log("❌ BACKEND ERROR DELETE /pagoestacion:", error.response?.data);
    return {
      ok: false,
      error: error.response?.data || "Error al eliminar pago de estación",
    };
  }
};